import { supabase } from "@/integrations/supabase/client";

/**
 * Fire-and-forget UI event tracker.
 * Inserts into `analytics_events` and never throws.
 */
export function trackEvent(
  event: string,
  properties: Record<string, unknown> = {},
) {
  try {
    const path =
      typeof window !== "undefined" ? window.location.pathname : null;
    // Don't await — keep UI snappy.
    void supabase
      .from("analytics_events")
      .insert({ event, properties: properties as any, path });
  } catch {
    // Silently ignore — analytics must never break the UI.
  }
}
